import Marionette from 'backbone.marionette';
import core_layouts from '../../../../core/layouts';
import pages from '../../views';
import { AdvertisingView } from '../../views';
import { sizes_for_big_ad } from '../../../../core/utils';

export default class AccountController extends Marionette.Object {

	settings() {
		const
			rootView = this.getOption('rootView'),
			rightSidebarLayout = new core_layouts.RightSidebar(),
			widgetsSidebar = new core_layouts.WidgetsSidebar(),
			accountSettings = new pages.AccountSettings();

		this.initAdvertisings(rootView, widgetsSidebar);

		rightSidebarLayout.getRegion('content').show(accountSettings);
		rightSidebarLayout.getRegion('sidebar').show(widgetsSidebar);

		rootView.getRegion('main').show(rightSidebarLayout);
	}

	communications() {
		const
			rootView = this.getOption('rootView'),
			rightSidebarLayout = new core_layouts.RightSidebar(),
			widgetsSidebar = new core_layouts.WidgetsSidebar(),
			communications = new pages.CommunicationsView();

		this.initAdvertisings(rootView, widgetsSidebar);

		rightSidebarLayout.getRegion('content').show(communications);
		rightSidebarLayout.getRegion('sidebar').show(widgetsSidebar);

		rootView.getRegion('main').show(rightSidebarLayout);
	}

	initAdvertisings(rootView, widgetsSidebar) {
		const
			advertisingSidebar = new AdvertisingView({
				ad_id:   'prizes-ad-slot-1',
				ad_path: 'prizes',
				size:    [ 300, 250 ],
				pos: 2,
			}),
			advertisingFooter = new AdvertisingView({
				ad_id:   'prizes-ad-slot-2',
				ad_path: 'prizes',
				size:    sizes_for_big_ad(),
				pos: 3,
			});

		widgetsSidebar.getRegion('ads_container').show(advertisingSidebar);
		rootView.getRegion('top_ads_container').show(advertisingFooter);
	}

	myHistory() {

	}

	changePassword() {

	}

	unsubscribe() {

	}
}